import { Crown, Trophy, Medal, Sparkles, Flame } from 'lucide-react';
import { useLeague } from '../../../../hooks';
import './winning-tokens.css';
import { ModeLeagueType } from '../../../../leagues';

interface WinnerToken {
  position: number;
  tokenNumber: number;
}

export const WinningTokens = ({ mode = 'main' }: { mode?: ModeLeagueType }) => {
  const { currentSeason } = useLeague();

  const winnersData =
    mode === 'arena' ? currentSeason?.arena.winners : currentSeason?.winners;

  const winners: WinnerToken[] = [];

  if (winnersData?.show) {
    for (let i = 1; i <= 10; i++) {
      const value = winnersData[`w${i}` as keyof typeof winnersData];

      if (typeof value === 'number') {
        winners.push({
          position: i,
          tokenNumber: value,
        });
      }
    }
  }

  const getConfig = (position: number) => {
    switch (position) {
      case 1:
        return {
          icon: Crown,
          emoji: '👑',
          label: 'CAMPEÓN',
          css: 'wt-first',
          color: '#cafb10',
        };
      case 2:
        return {
          icon: Trophy,
          emoji: '🥈',
          label: 'SUBCAMPEÓN',
          css: 'wt-second',
          color: '#90f7ff',
        };
      case 3:
        return {
          icon: Medal,
          emoji: '🥉',
          label: 'TERCER LUGAR',
          css: 'wt-third',
          color: '#5025e1',
        };
      default:
        return {
          icon: Sparkles,
          emoji: `#${position}`,
          label: `PUESTO ${position}`,
          css: 'wt-default',
        };
    }
  };

  const show = winnersData?.show;

  const cardNameArena: string = currentSeason?.arena.cardName ?? '';
  const cardNameMain: string = currentSeason?.cardName ?? '';

  const cardName: string = mode === 'arena' ? cardNameArena : cardNameMain;

  return (
    <div className="wt-wrapper">
      <h2 className="wt-title">
        Tókens Ganadores {cardName ? `de: "${cardName}"` : ''}
      </h2>

      {!show || winners.length === 0 ? (
        <div className="wt-empty">
          <Flame className="wt-empty-icon" stroke="#666" />
          <h3>Temporada Finalizada</h3>
          <p>Los tokens ganadores se revelarán pronto... ¡estáte pendiente!</p>
        </div>
      ) : (
        <>
          {/* <div className="wt-header">
            <Trophy className="wt-header-icon" />
            <h3>Tokens Ganadores</h3>
            <Trophy className="wt-header-icon" />
          </div> */}

          <div className="wt-podium">
            {winners.slice(0, 3).map((w) => {
              const cfg = getConfig(w.position);
              const Icon = cfg.icon;

              return (
                <div key={w.position} className={`wt-card ${cfg.css}`}>
                  <div className="wt-emoji">{cfg.emoji}</div>
                  <div className="wt-label">{cfg.label}</div>

                  <div className="wt-token" style={{ borderColor: cfg.color }}>
                    <div className="wt-token-label">Token Imperial</div>
                    <div className="wt-token-number">#{w.tokenNumber}</div>
                    <Icon className="wt-icon" stroke={cfg.color} />
                  </div>
                </div>
              );
            })}
          </div>

          {winners.length > 3 && (
            <div className="wt-others">
              <h4>Otros Ganadores</h4>

              <div className="wt-others-grid">
                {winners.slice(3).map((w) => {
                  const cfg = getConfig(w.position);
                  const Icon = cfg.icon;

                  return (
                    <div key={w.position} className="wt-other-card">
                      <div className="wt-pos">{w.position}</div>
                      <div className="wt-num">#{w.tokenNumber}</div>
                      <Icon className="wt-other-icon" />
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};
